import React from 'react';
import {AvGroup} from "availity-reactstrap-validation";
import {Col, Label, Row} from "reactstrap";
import AssetTypeService from "../../shared/service/AssetTypeService"
import AvField from "../../shared/component/form/AvField";

const defaultAssetNature = {
    id: '',
    name:'',
    assetTypeId: 1
    
};
export default class AssetNatureSave extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            assetNature: defaultAssetNature,
            assetTypeList:[],
            pageMode: null
        };
        this.assetTypeService=new AssetTypeService();
    }

    componentDidMount = () => {
        this.clearData();
        this.assetTypeService.findAll().then(response => this.setState({assetTypeList: response}));
    }

    render() {
        return (
            <Row className="justify-content-center">
                <Col>
                    <AvGroup>
                        <Label for="assetTypeId">Varlık Tipi<span style={{color: 'red'}}> (*)</span>
                        </Label>
                        <AvField
                            type="select"
                            className="form-control"
                            name="assetTypeId"
                            value={this.state.assetNature.assetTypeId}
                            validate={{
                                required: {
                                    value: true,
                                    errorMessage: 'Bu alan zorunlu.'
                                }
                            }}
                            onChange={this.__handleChange}>
                        <option value='' key=''/>
                        {this.state.assetTypeList.map(element => (
                            <option value={element.id} key={element.id}>
                                {element.name}
                            </option>
                        ))}
                        </AvField>
                    </AvGroup>
                    <AvGroup>
                        <Label for="name">Keşif Cihazı Adı<span style={{color: 'red'}}> (*)</span>
                        </Label>
                        <AvField
                            type="text"
                            className="form-control"
                            name="name"
                            validate={{
                                required: {
                                    value: true,
                                    errorMessage: 'Bu alan zorunlu.'
                                },
                                minLength: {
                                    value: 1,
                                    errorMessage: 'Bu alan en az 1 karakterden oluşabilir.'
                                },
                                maxLength: {
                                    value: 50,
                                    errorMessage: 'Bu alan en fazla 50 karakterden oluşabilir.'
                                }
                            }}
                            value={this.state.assetNature.name}
                            onChange={this.__handleChange}
                        />
                    </AvGroup>
                </Col>
            </Row>
        );
    }

    __handleChange = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        let assetNature = this.state.assetNature;
        assetNature[e.target.name] = value;
        this.setState({assetNature: assetNature});
    }

    setData = (data, pageMode) => {
        data.assetTypeId= data.assetTypeId ?  data.assetTypeId.id: null
        this.setState({assetNature: data, pageMode: pageMode});
    }

    getData = () => {
        return this.state.assetNature;
    }

    clearData = () => {
        this.setState({assetNature: Object.assign({}, defaultAssetNature), pageMode: null});
    }

}
